import type { ReactNode } from 'react';

export const symbol_approval_delegation_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m570-616 214-213q8-8 20-8t21 8q9 8.07 9 20.53 0 12.47-9 21.47L591-552q-5 5-10.13 7-5.14 2-11 2-5.87 0-10.87-2-5-2-10-7L427-674q-9-9-9-21t9-21.39q9-8.61 21.5-8.61t21.5 9l100 100ZM295-438v238l307 90 188-59-66-66H589q-16.21 0-31.6-2.5Q542-240 527-245l-96-29q-13-4-19-15.5t-2-24.34q4-12.85 15.6-19.5Q437.2-340 450-335l94 32q11.1 3.75 22.55 6.37Q578-294 589-294h76l-56-56-230-88h-84ZM590-53l-295-84q0 23-17 40t-40.05 17H140q-24.75 0-42.37-17.63Q80-115.25 80-140v-298q0-24.75 17.63-42.38Q115.25-498 140-498h238q5.33 0 10.67 1 5.33 1 10.33 3l106 40 335 334-216 67q-8.17 2-17.09 2Q598-51 590-53Zm279 5q-9 9-21 9t-21-9L60-815q-9-9-9-21t9-21q9-9 21-9t21 9L869-90q9 9 9 21t-9 21Zm-729-92h94v-298h-94v298Z"
		/>
	</svg>
);
